import React, { useEffect, useState } from "react";
import CommonTable from "../../../components/comman/CommonTable";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { callApi } from "../../../ApiHelper/ApiHelper";
import ViewIcon from "../../../components/Icons/ViewIcon";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { formatAmount } from "../../../utility/CommonFunctions";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import {
  Nav,
  NavItem,
  NavLink,
  Spinner,
  TabContent,
  Fade,
  TabPane,
} from "reactstrap";

const PendingPaymentTicketsTabWise = ({ siteId }) => {
  const navigate = useNavigate();

  const [pageStates, setPageStates] = useState({
    tableLoader: false,
    paymentTicketList: [],
    activeTabForPendingPT: "AgainstPO",
  });

  useEffect(() => {
    GetPaymentTicket();
  }, [siteId, pageStates?.activeTabForPendingPT]);

  const GetPaymentTicket = () => {
    let options = {
      method: "GET",
    };
    const Url =
      apiUrl.get_payment_ticket +
      `pageNumber=1&pageSize=5&status=pending&type=${pageStates?.activeTabForPendingPT}${siteId ? `&siteId=${siteId}` : ""}`;
    setPageStates((pre) => ({
      ...pre,
      tableLoader: true,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: false,
      }));
      if (res?.status === true) {
        const newData = res?.data?.paymentTicket?.map((item) => ({
          ...item,
          paymentTicketNumber: item?.ticketNumber,
          siteName: item?.site?.name,
          paymentDate: moment(item?.date).format("DD-MM-YYYY"),
          createdBy: item?.user?.name,
          paymentTicketStatus: item?.status,
          paymentStatus:
            item?.remainingAmount === item?.totalAmount
              ? 0
              : item?.remainingAmount === 0
                ? 1
                : 2,
          grandTotal: formatAmount(item?.totalAmount),
          vendorName: item?.purchase?.vendor?.name,
          expenseName:
            item?.paymentticketexpenseheads[0]?.expensehead?.name +
            `${
              item?.paymentticketexpenseheads?.length > 1
                ? ` + ${item?.paymentticketexpenseheads?.length - 1}`
                : ""
            }`,
          payTerms: item?.purchase?.paymentTerms,
          remaining: formatAmount(item?.remainingAmount),
          paidAmount: formatAmount(item?.totalAmount - item?.remainingAmount),
        }));
        setPageStates((pre) => ({
          ...pre,
          paymentTicketList: newData,
        }));
      }
    });
  };

  const toggleTab = (tab) => {
    setPageStates((prev) => ({
      ...prev,
      activeTabForPendingPT: tab,
    }));
  };

  const PendingPaymentTicketsHeading = [
    { value: "paymentTicketNumber", label: "Ticket Number" },
    { value: "siteName", label: "Site Name" },
    { value: "paymentDate", label: "Date" },
    { value: "expenseName", label: "Expense Name" },
    { value: "createdBy", label: "Created By" },
    { value: "grandTotal", label: "Total Amount" },
    { value: "paymentTicketStatus", label: "Status" },
  ];
  const HandleViewPendingPT = (data) => {
    navigate(RoutesLink.payment_tickets_details + `/${data?.type}/${data?.id}`);
  };
  const ActionDataForPendingPT = [
    {
      label: "view",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleViewPendingPT,
    },
  ];

  const getRoute = () => {
    switch (pageStates?.activeTabForPendingPT) {
      case "AgainstPO":
        return RoutesLink?.payment_ticket_against_po;
      case "General":
        return RoutesLink?.payment_ticket_general;
      case "Reimbursement":
        return RoutesLink?.payment_ticket_reimbursement;
      default:
        return "";
    }
  };

  return (
    <div className="col-12 col-lg-12">
      <div className="card">
        <div className="card-body">
          <div className="card-head">
            <h3 className="card-title">Pending Payment Tickets</h3>

            <button
              type="button"
              className="btn btn-outline-primary py-1"
              onClick={() => navigate(getRoute())}
            >
              View All {pageStates?.activeTabForPendingPT}
            </button>
          </div>
          <Nav tabs className="nav nav-tabs border-0 mb-4">
            <NavItem className="nav-item">
              <NavLink
                className={
                  pageStates?.activeTabForPendingPT === "AgainstPO"
                    ? "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-2 border-start-2 active"
                    : "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-2 border-start-2"
                }
                style={{ cursor: "pointer" }}
                onClick={() => toggleTab("AgainstPO")}
              >
                Against PO
              </NavLink>
            </NavItem>
            <NavItem className="nav-item ">
              <NavLink
                className={
                  pageStates?.activeTabForPendingPT === "General"
                    ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-2 border-start-0 active"
                    : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-2 border-start-0"
                }
                style={{ cursor: "pointer" }}
                onClick={() => toggleTab("General")}
              >
                General
              </NavLink>
            </NavItem>
            <NavItem className="nav-item ">
              <NavLink
                className={
                  pageStates?.activeTabForPendingPT === "Reimbursement"
                    ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0 active"
                    : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0"
                }
                style={{ cursor: "pointer" }}
                onClick={() => toggleTab("Reimbursement")}
              >
                Reimbursement
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={pageStates?.activeTabForPendingPT}>
            <TabPane tabId={"AgainstPO"}>
              <Fade
                in={pageStates?.activeTabForPendingPT === "AgainstPO"}
                timeout={200}
              >
                <CommonTable
                  TableHeading={PendingPaymentTicketsHeading}
                  TableData={pageStates?.paymentTicketList}
                  ActionData={ActionDataForPendingPT}
                  isLoading={pageStates?.tableLoader}
                />
              </Fade>
            </TabPane>
            <TabPane tabId={"General"}>
              <Fade
                in={pageStates?.activeTabForPendingPT === "General"}
                timeout={200}
              >
                <CommonTable
                  TableHeading={PendingPaymentTicketsHeading}
                  TableData={pageStates?.paymentTicketList}
                  ActionData={ActionDataForPendingPT}
                  isLoading={pageStates?.tableLoader}
                />
              </Fade>
            </TabPane>
            <TabPane tabId={"Reimbursement"}>
              <Fade
                in={pageStates?.activeTabForPendingPT === "Reimbursement"}
                timeout={200}
              >
                <CommonTable
                  TableHeading={PendingPaymentTicketsHeading}
                  TableData={pageStates?.paymentTicketList}
                  ActionData={ActionDataForPendingPT}
                  isLoading={pageStates?.tableLoader}
                />
              </Fade>
            </TabPane>
          </TabContent>
        </div>
      </div>
    </div>
  );
};

export default PendingPaymentTicketsTabWise;
